import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * After email verification (or any sign-in), if a pending invite code is
 * stored in localStorage, send the user to /invite?code=... once.
 */
const PendingInviteResumer = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading || !user) return;
    if (location.pathname.startsWith("/invite")) return;
    let pending: string | null = null;
    try {
      pending = localStorage.getItem("pending_invite_code");
    } catch {}
    if (!pending) return;
    try {
      localStorage.removeItem("pending_invite_code");
    } catch {}
    navigate(`/invite?code=${encodeURIComponent(pending)}`, { replace: true });
  }, [user, loading, location.pathname, navigate]);

  return null;
};

export default PendingInviteResumer;